import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Accordion, Card, Button, Form } from 'react-bootstrap';
import { gather_source, ReportPlot } from './Javascript/GenerateReport.js';
import * as RO from './Javascript/ReportObjects.js';
import * as IN from './Javascript/IncidentsReport.js';
import * as VR from './Javascript/VesselReport.js';
import * as G from './Javascript/General.js';
import * as D from './Javascript/DownloadPDF.js';
import RouteIncidents from './RouteIncidents';
import MapComponent from './MapComponent';
import './CSS/Bootstrap/bootstrap.css';
import Plot from 'react-plotly.js';
import './CSS/style.css';

interface Props {
}

const VesselReport: React.FC<Props> = () => {
    const [is_loading, set_is_loading] = useState(true);
    const [are_ids_valid, set_are_ids_valid] = useState(true);
    const [are_classes_valid, set_are_classes_valid] = useState(true);
    const [includeMercury, setIncludeMercury] = useState(false);
    const [includeValue, setIncludeValue] = useState(false);
    const [vesselDetails, setVesselDetails] = useState<RO.VesselDetailed | null>(null);
    const [vesselTitle, setVesselTitle] = useState<String>("");
    const [vesselCoords, setVesselCoords] = useState<String[]>([]);
    const [vesselMercuryCoords, setVesselMercuryCoords] = useState<String[]>([]);

    const call_generate_pdf = async ( dl_type: string) => {
          let title_cont = document.querySelectorAll(".incident_total_cont");

          title_cont.forEach(function(cont) {
              let titlesToRemove = cont.querySelectorAll(".sub_title");
              titlesToRemove.forEach(function(title) {
                  title.remove();
              });
          });

          if (are_ids_valid && are_classes_valid) {
              G.setPagePortrait(true);
              gather_source([], [], "page_break", null, true);
              if(dl_type == 'pdf'){
                gather_source([], [], "download_pdf", null, true);
              }
              else if(dl_type == 'word'){
                gather_source([], [], "download_word", null, true);
              }
              else if(dl_type == 'excel'){
                gather_source([], [], "download_excel", null, true);
              }
          }
      };

    useEffect(() => {
        if(!is_loading){
            var download_btn = document.getElementById("download_pdf_btn") as HTMLButtonElement;
            if(download_btn){
                download_btn.disabled = false;
                download_btn.addEventListener('click', () => call_generate_pdf('pdf'));
            }
        }
    }, [is_loading]);

    const reloadMap = () => {
        window.location.reload();
    };

    useEffect(() => {
        const fetchDetails = async () => {
            try{
                if(RO.current_user && vesselDetails == null) {
                    const res = await VR.getVesselReportDetails(RO.template_uuid);
                    //const res = await VR.getVesselReportDetails(RO.current_user);
                    if(res != null) setVesselDetails(res);
                }
            } catch (error) {
                console.error(error);
            } finally {
                if (vesselDetails !== null) set_is_loading(false);
            }
        }
        fetchDetails();
    }, [vesselDetails]);

    useEffect(() => {
            if(vesselDetails) {
                if(RO.coord_format === "DDM" && vesselDetails.coordinate.Ddm?.LonString !== undefined &&
                vesselDetails.coordinate.Ddm?.LatString !== undefined){
                    setVesselCoords([vesselDetails.coordinate.Ddm?.LonString, vesselDetails.coordinate.Ddm?.LatString]);
                    if(vesselDetails.mercury.mercury_coordinate && vesselDetails.mercury.mercury_coordinate.Ddm?.LonString !== undefined &&
                        vesselDetails.mercury.mercury_coordinate.Ddm?.LatString !== undefined) {
                        setVesselMercuryCoords([vesselDetails.mercury.mercury_coordinate.Ddm.LonString, vesselDetails.mercury.mercury_coordinate.Ddm.LatString]);
                    }
                }
                else if(RO.coord_format === "DMS" && vesselDetails.coordinate.Dms?.LonString !== undefined &&
                    vesselDetails.coordinate.Dms?.LatString !== undefined){
                    setVesselCoords([vesselDetails.coordinate.Dms.LonString, vesselDetails.coordinate.Dms.LatString]);
                    if(vesselDetails.mercury.mercury_coordinate && vesselDetails.mercury.mercury_coordinate.Dms?.LonString !== undefined &&
                        vesselDetails.mercury.mercury_coordinate.Dms?.LatString !== undefined) {
                        setVesselMercuryCoords([vesselDetails.mercury.mercury_coordinate.Dms?.LonString, vesselDetails.mercury.mercury_coordinate.Dms?.LatString]);
                    }
                }
                else{
                    setVesselCoords([vesselDetails.coordinate.dec.lon.toString(), vesselDetails.coordinate.dec.lat.toString()]);
                    if(vesselDetails.mercury.mercury_coordinate) {
                        setVesselMercuryCoords([vesselDetails.mercury.mercury_coordinate.dec.lon.toString(), vesselDetails.mercury.mercury_coordinate.dec.lat.toString()]);
                    }
                }
            }
        }, [vesselDetails]);

    return (
    <div id="single_incident_container">
       {is_loading || vesselDetails == null ? (
            <div id="loading">Loading...<span className="rotating-arrows">&#8635;</span></div>
       ) : (
       <>
            <div id="top_btn_panel">
                <button type="button" id="download_pdf_btn" disabled> Download PDF </button>
                <button style={{display:'none'}} type="button" onClick={() => call_generate_pdf('word')}> Download Word </button>
                <button style={{display:'none'}} type="button" onClick={() => call_generate_pdf('excel')}> Download excel </button>
                <div className="top_menu_item">
                    <button type="button" className="button_style" onClick={reloadMap}>Reload Report</button>
                </div>
            </div>
            <div id="vessel_report_header" className="report_row vessel_report_row">
                { vesselDetails?.flag?.flag_url ? (
                <div className="left">
                    <img src={`Images/Assets/Flags/${vesselDetails?.flag.flag_url}`} />
                </div>
                ) : null}
                <div className="right">
                    <h1 id="report_title">{G.displayValue(vesselDetails?.vessel_name)}</h1>
                    <h1>{G.displayValue(vesselDetails?.vessel_type_name)}</h1>
                </div>
                <div className="clear_both"></div>
            </div>
            <div className="report_row vessel_report_row">
                <div className="inner_padding">
                    <p className="sub_title">General Details</p>
                    <table className="vessel_report_table">
                    <tbody>
                        <tr>
                            <td className="left"><span className="title">Name</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.vessel_name)}</td>
                            <td className="left"><span className="title">AIS Name</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.vessel_ais_name)}</td>
                        </tr>
                        <tr>
                            <td className="left"><span className="title">Type</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.vessel_type_name)}</td>
                            <td className="left"><span className="title">AIS Type</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.ais_vessel_type_simple)}</td>
                        </tr>
                        <tr>
                            <td className="left"><span className="title">MMSI</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.mmsi)}</td>
                            <td className="left"><span className="title">IMO</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.imo)}</td>
                        </tr>
                        <tr>
                            <td className="left"><span className="title">Call Sign</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.callsign)}</td>
                            <td className="left"><span className="title">Year of Build</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.built_year)}</td>
                        </tr>
                        <tr>
                            <td className="left"><span className="title">Flag</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.flag.flag_name)}</td>
                            <td className="left"><span className="title">Tanker Code</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.tanker_trade_code)}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div className="clear_both"></div>
            </div>
            <div className="report_row vessel_report_row">
                <div className="inner_padding">
                    <p className="sub_title">Dimensions</p>
                    <table className="vessel_report_table">
                    <tbody>
                        <tr>
                            <td className="left"><span className="title">Beam</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.dimensions.beam)}</td>
                            <td className="left"><span className="title">Bale CC</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.dimensions.bale_cubic)}</td>
                        </tr>
                        <tr>
                            <td className="left"><span className="title">LOA</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.dimensions.loa)}</td>
                            <td className="left"><span className="title">Grain CC</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.dimensions.grain_cubic)}</td>
                        </tr>
                        <tr>
                            <td className="left"><span className="title">DWT</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.dimensions.dwt)}</td>
                            <td className="left"><span className="title">Liquid CC</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.dimensions.liquid_cubic_98_percent)}</td>
                        </tr>
                        <tr>
                            <td className="left"><span className="title">GT</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.dimensions.gross_tonnage)}</td>
                            <td className="left"><span className="title">TEU Capacity</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.dimensions.max_teus)}</td>
                        </tr>
                        <tr>
                            <td className="left"><span className="title">NT</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.dimensions.net_tonnage)}</td>
                            <td className="left"><span className="title">Max Draught</span></td>
                            <td className="right">{G.displayValue(vesselDetails?.dimensions.maximum_draught)}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div className="clear_both"></div>
            </div>
            {Object.entries(vesselDetails.company || {}).map(([key, companyInfo]) => {
                const info = companyInfo as RO.CompanyInfo | null; // Explicitly type

                return info ? (
                  <div className="report_row vessel_report_row" key={key}>
                    <div className="inner_padding">
                      <p className="sub_title">
                        {key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                      </p>
                      <table className="vessel_report_table">
                        <tbody>
                          <tr>
                            <td className="left"><span className="title">Name</span></td>
                            <td className="right">{info.short_name || "N/A"}</td>
                            <td className="left"></td>
                            <td className="right"></td>
                          </tr>
                          <tr>
                            <td className="left"><span className="title">Type</span></td>
                            <td className="right">{info.company_type || "N/A"}</td>
                            <td className="left"><span className="title">Country</span></td>
                            <td className="right">{info.country_name || "N/A"}</td>
                          </tr>
                          {info.website && (
                            <tr>
                              <td className="left"><span className="title">Website</span></td>
                              <td className="right">
                                <a href={info.website} target="_blank" rel="noopener noreferrer">
                                  {info.website}
                                </a>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                        <div className="clear_both"></div>
                  </div>
                ) : null;
            })}
            {includeMercury && vesselDetails.mercury != null && vesselDetails?.mercury.mercury_box_id != "" ? (
                <div className="report_row vessel_report_row">
                    <div className="inner_padding">
                        <p className="sub_title">Mercury</p>
                        <table className="vessel_report_table">
                        <tbody>
                            <tr>
                                <td className="left"><span className="title">Box ID</span></td>
                                <td className="right">{G.displayValue(vesselDetails?.mercury.mercury_box_id)}</td>
                                <td className="left"><span className="title">Date / Time</span></td>
                                <td className="right">{G.displayValue(vesselDetails?.mercury.mercury_time?.toString().replace("T", " "))}</td>
                            </tr>
                            <tr>
                                <td className="left"><span className="title">Latitude</span></td>
                                <td className="right">{G.displayValue(vesselDetails?.mercury.mercury_coordinate?.dec?.lat)}</td>
                                <td className="left"><span className="title">Longitude</span></td>
                                <td className="right">{G.displayValue(vesselDetails?.mercury.mercury_coordinate?.dec?.lon)}</td>
                            </tr>
                            <tr>
                                <td className="left"><span className="title">Velocity</span></td>
                                <td className="right">{G.displayValue(vesselDetails?.mercury.mercury_velocity?.knots)}</td>
                                <td className="left"><span className="title">Direction</span></td>
                                <td className="right">{G.displayValue(vesselDetails?.mercury.mercury_dir)}</td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                    <div className="clear_both"></div>
                </div>
            ) : null}
            {includeValue && vesselDetails.value != null && vesselDetails?.value.hull != "" ? (
                <div className="report_row vessel_report_row">
                        <div className="inner_padding">
                            <p className="sub_title">Vessel Value</p>
                            <table className="vessel_report_table">
                            <tbody>
                                <tr>
                                    <td className="left"><span className="title">Hull</span></td>
                                    <td className="right">{G.displayValue(vesselDetails?.value.hull)}</td>
                                    <td className="left"><span className="title">IV</span></td>
                                    <td className="right">{G.displayValue(vesselDetails?.value.iv)}</td>
                                </tr>
                                <tr>
                                    <td className="left"><span className="title">Loss of Hire</span></td>
                                    <td className="right">{G.displayValue(vesselDetails?.value.loss_of_hire)}</td>
                                    <td className="left"><span className="title">Total</span></td>
                                    <td className="right">{G.displayValue(vesselDetails?.value.calculated_total)}</td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                        <div className="clear_both"></div>
                </div>
            ) : null}
       </>
       )}
    </div>
)};
export default VesselReport;